import React from 'react';
import { Form, Input, Select, Typography, Switch, Row, Col } from 'antd';

const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const PivotNodeProperties = ({ config, inputSchema }) => {
  const isPivot = config.operation !== 'unpivot';
  
  return (
    <>
      <Form.Item label="Operation" name="operation" initialValue={config.operation || 'pivot'}>
        <Select>
          <Option value="pivot">Pivot (rows to columns)</Option>
          <Option value="unpivot">Unpivot (columns to rows)</Option>
        </Select>
      </Form.Item>

      {isPivot ? (
        <>
          <Form.Item label="Index Columns" name="indexColumns" initialValue={config.indexColumns || []} rules={[{ required: true }]}>
            <Select mode="tags" placeholder="Columns to use as index (rows)">
              {inputSchema && inputSchema.map(col => (
                <Option key={col.name} value={col.name}>{col.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Pivot Column" name="pivotColumn" initialValue={config.pivotColumn || ''} rules={[{ required: true }]}>
            {inputSchema && inputSchema.length > 0 ? (
              <Select placeholder="Column whose values become new column headers" showSearch>
                {inputSchema.map(col => (
                  <Option key={col.name} value={col.name}>{col.name}</Option>
                ))}
              </Select>
            ) : (
              <Input placeholder="Column whose values become new column headers" />
            )}
          </Form.Item>

          <Form.Item label="Value Column" name="valueColumn" initialValue={config.valueColumn || ''} rules={[{ required: true }]}>
            {inputSchema && inputSchema.length > 0 ? (
              <Select placeholder="Column to aggregate" showSearch>
                {inputSchema.map(col => (
                  <Option key={col.name} value={col.name}>{col.name}</Option>
                ))}
              </Select>
            ) : (
              <Input placeholder="Column to aggregate" />
            )}
          </Form.Item>

          <Form.Item label="Aggregation Function" name="aggFunction" initialValue={config.aggFunction || 'sum'}>
            <Select>
              <Option value="sum">Sum</Option>
              <Option value="mean">Mean</Option>
              <Option value="count">Count</Option>
              <Option value="min">Min</Option>
              <Option value="max">Max</Option>
              <Option value="first">First</Option>
              <Option value="last">Last</Option>
            </Select>
          </Form.Item>
        </>
      ) : (
        <>
          <Form.Item label="ID Columns" name="idColumns" initialValue={config.idColumns || []} rules={[{ required: true }]}>
            <Select mode="tags" placeholder="Columns to keep as identifiers">
              {inputSchema && inputSchema.map(col => (
                <Option key={col.name} value={col.name}>{col.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Value Columns" name="valueColumns" initialValue={config.valueColumns || []}>
            <Select mode="tags" placeholder="Columns to unpivot (optional - all others if empty)">
              {inputSchema && inputSchema.map(col => (
                <Option key={col.name} value={col.name}>{col.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="Variable Name" name="variableName" initialValue={config.variableName || 'variable'}>
                <Input placeholder="Name for the new variable column" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Value Name" name="valueName" initialValue={config.valueName || 'value'}>
                <Input placeholder="Name for the new value column" />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>{isPivot ? 'Pivot' : 'Unpivot'} Node:</strong><br/>
          {isPivot ? (
            <>
              • Converts rows to columns<br/>
              • Index columns become row identifiers<br/>
              • Pivot column values become new column headers<br/>
              • Value columns are aggregated
            </>
          ) : (
            <>
              • Converts columns to rows<br/>
              • ID columns are preserved<br/>
              • Value columns become rows in new variable/value columns<br/>
              • Useful for transforming wide to long format
            </>
          )}
        </Text>
      </div>
    </>
  );
};

export default PivotNodeProperties;